export const REMEMBER_EMAIL_KEY = "rememberEmail";
export const USE_PASSWORD_KEY = "usePassword";
